// extracted by mini-css-extract-plugin
export default {"image":"G3-z","loaded":"H3-z"};